
import React from 'react';
import { enableStaticRendering } from 'mobx-react';
import RootStore from './root-store';
import UserStore from './user-store';
import OptionStore from './option-store';
import EventStore from './event-store';
import NewsStore from './news-store';
import PaymentStore from './payment-store';
import PermissionStore from './permission-store';
import PublicStore from './public-store';
import NotificationStore from './notification-store';

type CompositeStore = {
  rootStore: RootStore,
  userStore: UserStore,
  optionStore: OptionStore,
  eventStore:EventStore,
  newsStore:NewsStore,
  paymentStore: PaymentStore,
  permissionStore: PermissionStore,
  publicStore: PublicStore,
  notificationStore: NotificationStore,
};

const isServer = typeof window === "undefined";
// eslint-disable-next-line react-hooks/rules-of-hooks
enableStaticRendering(isServer);

// let _stores: null | CompositeStore = null;

const initStores = () => {
  const rootStore = new RootStore();
  const initializedStores: CompositeStore = {
    rootStore,
    userStore: rootStore.userStore,
    optionStore: rootStore.optionStore,
    eventStore: rootStore.eventStore,
    newsStore: rootStore.newsStore,
    paymentStore: rootStore.paymentStore,
    permissionStore: rootStore.permissionStore,
    publicStore: rootStore.publicStore,
    notificationStore: rootStore.notificationStore,
  };
  return initializedStores;
};

export const stores = initStores(); // _stores || initStores();

export const StoreContext = React.createContext(stores);
// @ts-ignore
export const StoreProvider = ({ children }) => <StoreContext.Provider value={stores}>{children}</StoreContext.Provider>;
